<template>
  <v-layout row wrap>
    <v-flex v-show="false - value">
      <input type="file" id="file" ref="myFiles" @input="setFiles" multiple />
    </v-flex>
    <v-flex xs12>
      <v-btn outline depressed @click="$refs.myFiles.click()" v-bind="$attrs">
        Add Attachments
      </v-btn>
    </v-flex>
    <v-flex pa-0 pt-2 xs12 v-for="(file, index) in files" :key="file.name">
      {{ file.name }}
      <v-btn
        outline
        depressed
        small
        color="error"
        v-bind="$attrs"
        @click="[files.splice(index, 1), $emit('input', files)]"
      >
        Remove
      </v-btn>
      <ControlTextArea
        v-model="file.comments"
        :label="`Comments (${file.name})`"
        @input="$emit('input', files)"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import ControlTextArea from './ControlTextArea'

export default {
  components: {
    ControlTextArea,
  },
  inheritAttrs: false,
  props: ['value'],
  data: () => ({
    files: [],
  }),
  watch: {
    value() {
      if (!this.value) {
        this.files = []
      }
    },
  },
  methods: {
    setFiles() {
      const fileList = this.$refs.myFiles.files
      let i = 0
      let file = fileList['' + i]
      const newSelectedfiles = []
      while (file) {
        newSelectedfiles.push(file)
        file = fileList['' + ++i]
      }
      const currentlySelectedFileNames = this.files.map((file) => file.name)
      const unselectedFiles = newSelectedfiles.filter((file) =>
        currentlySelectedFileNames.every((filename) => filename !== file.name)
      )
      unselectedFiles.forEach((file) => {
        this.$set(file, 'comments', '')
        this.files.push(file)
      })
      this.$emit('input', this.files)
      this.$refs.myFiles.value = ''
    },
  },
}
</script>
